import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    loadingText: {
        color: theme.palette.secondary.main,
    },
    loadingIcon: {
        width: 32,
        height: 32,
    },
}));
